import { AuthConst } from '@/store/constant/auth.constant'

import { AuthUnionType } from '@/store/actions/auth.action'

import { IAuthState } from '@/store/models/auth.model'

const intialState: IAuthState = {
    signup: {
        loaded: false,
        success: false,
        message: ''
    },
    signin: {
        loaded: false,
        success: false,
        message: ''
    },
    userInfo: null,
    authInfo: null
}

export default function authReducer(
    state = intialState,
    action: AuthUnionType
): any {
    switch (action.type) {
    // 登录
        case AuthConst.SIGNIN:
            return {
                ...state,
                signin: {
                    loaded: false,
                    success: false,
                    message: ''
                }
            }
        case AuthConst.SIGNIN_SUCCESS:
            return {
                ...state,
                signin: {
                    loaded: true,
                    success: true,
                    message: action.payload
                },
                signup: {
                    loaded: false,
                    success: false,
                    message: ''
                }
            }
        case AuthConst.SIGNIN_FAIL:
            return {
                ...state,
                signin: {
                    loaded: true,
                    success: false,
                    message: action.payload
                }
            }
        case AuthConst.SIGNUP:
            return {
                ...state,
                signup: {
                    loaded: false,
                    success: false
                }
            }
        case AuthConst.SIGNUP_SUCCESS:
            return {
                ...state,
                signin: {
                    loaded: true,
                    success: false,
                    message: ''
                },
                signup: {
                    loaded: true,
                    success: true,
                    message: action.message
                }
            }
        case AuthConst.SIGNUP_FAIL:
            return {
                ...state,
                signup: {
                    loaded: true,
                    success: false,
                    message: action.message
                }
            }
            // 存登录信息
        case AuthConst.SETUSERINFO:
            return {
                ...state,
                userInfo: action.payload
            }
            // 存权限
        case AuthConst.SETAUTH:
            return {
                ...state,
                authInfo: action.payload
            }
        default:
            return state
    }
}
